import React from "react";
import * as MabnaButton from "../../Button/Button";

import KeyValueTable from "../../DataPresenters/keyValueTable";
import { Price, covertNumToPrice } from "../../../../helpers/utility";

import prop from "ramda/es/prop";
import DiscountInput from "../../DiscountInput";

import "rc-checkbox/assets/index.css";
import "./order-payment-info.scss";

const orderFields = [
  {
    key: "service",
    title: "عنوان سرویس",
    renderer: prop("title")
  },
  {
    key: "amount",
    title: "قیمت",
    renderer: amount => <Price>{amount}</Price>
  }
];

const paymentAmountFields = [
  {
    key: "paymentAmount",
    title: "قابل پرداخت",
    renderer: price => <Price literalZero={true}>{price}</Price>
  }
];

const OrderPaymentInfo = ({
  order = {},
  onPaymentRequest,
  finalPrice,
  needsBankPayment = true,
  onDiscountRequest,
  onUseCreditChange,
  shouldUseCredit,
  userCreditAmount,
  userCoins,
  priceAfterDiscount
}) => {
  const shouldUseCreditInputBeDisabled = order.amount === 0 || finalPrice === 0;

  const shouldUseCreditInputBeChecked = Boolean(
    shouldUseCredit && order.amount !== 0 && finalPrice !== 0
  );

  const useCreditInputTitle = `استفاده از اعتبار شما (${covertNumToPrice(
    userCreditAmount || 0
  )})`;

  const useAbleCredit = shouldUseCredit ? userCreditAmount : 0;

  const handleUseCreditChange = event =>
    onUseCreditChange(event.target.checked);

  const handleDiscountSubmit = submitEvent => {
    submitEvent.preventDefault();
    onDiscountRequest(submitEvent.target.promo_code.value);
  };

  // const priceToPay = Math.max(finalPrice || order.service.price - useAbleCredit, 0)
  const priceToPay = Math.max(finalPrice || order.amount - useAbleCredit, 0);

  const canPayWithCoins = order.coins_cost > 0 && userCoins > order.coins_cost;

  return (
    <section className="order-payment-info">
      <KeyValueTable data={order} propertiesToShow={orderFields} />

      <hr />

      <DiscountInput
        priceAfterDiscount={priceAfterDiscount}
        // hidePriceAfterDiscount={!priceAfterDiscount}
        applyDiscount={handleDiscountSubmit}
      />

      <label className="use-credit-checkbox">
        <input
          type="checkbox"
          disabled={shouldUseCreditInputBeDisabled}
          checked={shouldUseCreditInputBeChecked}
          onChange={handleUseCreditChange}
        />
        <span>{useCreditInputTitle}</span>
      </label>

      <hr />

      <KeyValueTable
        data={{ paymentAmount: priceToPay }}
        propertiesToShow={paymentAmountFields}
      />

      <hr />

      <MabnaButton.Primary onClick={() => onPaymentRequest()}>
        {needsBankPayment ? "پرداخت" : "اتمام خرید"}
      </MabnaButton.Primary>

      {canPayWithCoins && (
        <MabnaButton.Secondary onClick={() => onPaymentRequest(true)}>
          پرداخت با سکه ( {order.coins_cost} عدد )
        </MabnaButton.Secondary>
      )}
    </section>
  );
};

export default OrderPaymentInfo;



// WEBPACK FOOTER //
// ./src/components/common/orders/OrderPaymentOptions/OrderPaymentInfo.js